import { CLUB_POINTS_GUIDE_SECTIONS, formatGuidePoints } from '@/lib/points/club-points-guide';
import { Sheet } from '@/components/shared/Sheet';

interface Props {
  onClose: () => void;
}

export function ClubPointsGuideSheet({ onClose }: Props) {
  return (
    <Sheet title="How to Earn Points" onClose={onClose}>
      <div className="space-y-5 px-4 pb-8 pt-2">
        <div className="rounded-xl border border-gold/40 bg-gold/5 p-3.5">
          <div className="font-serif text-base font-bold text-navy">🏆 Bag Tag Club Points</div>
          <p className="mt-1.5 text-xs leading-relaxed text-ink-soft">
            Club points are awarded automatically based on play, community activity, and achievements.
            They determine your rank on the Bag Tag leaderboard. Status only — no cash value.
          </p>
          <p className="mt-2 text-[11px] font-semibold text-mute">
            Side game money settings never affect club points.
          </p>
        </div>

        {CLUB_POINTS_GUIDE_SECTIONS.map((section) => (
          <section key={section.id}>
            <h3 className="font-serif text-[15px] font-bold text-navy">{section.title}</h3>
            {section.subtitle && (
              <p className="mt-0.5 text-[11px] leading-snug text-mute">{section.subtitle}</p>
            )}
            <div className="mt-2 overflow-hidden rounded-xl border border-line bg-paper">
              {section.items.map((item, i) => (
                <div
                  key={item.label}
                  className={`flex items-start justify-between gap-3 px-3.5 py-2.5 ${
                    i > 0 ? 'border-t border-line/80' : ''
                  }`}
                >
                  <div className="min-w-0 flex-1">
                    <div className="text-xs font-semibold text-ink">{item.label}</div>
                    {item.note && (
                      <div className="mt-0.5 text-[10px] leading-snug text-mute">{item.note}</div>
                    )}
                  </div>
                  <div
                    className={`shrink-0 text-sm font-extrabold tabular-nums ${
                      item.points == null
                        ? 'text-mute'
                        : item.points > 0
                          ? 'text-good'
                          : 'text-bad'
                    }`}
                  >
                    {formatGuidePoints(item.points)}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}

        <p className="text-center text-[10px] leading-relaxed text-mute">
          Points are applied when you post rounds and complete eligible activities.
          Some categories are rolling out — totals always reflect your points ledger.
        </p>
      </div>
    </Sheet>
  );
}
